<mat-icon class="size-auto score-icon" [ngClass]="wrapperClass">
    <i [class]="iconClass"></i>
</mat-icon>
